import React, { } from 'react';

import SimpleDialog from 'generics/components/simple-dialog';

import { ReactComponent as CloseIcon } from 'assets/images/close-button-icon.svg';

import './index.scss';

function EventJoiningInstructions(props) {

  const { instruction, onClose } = props;

  function renderDialogHeader() {

    const closeButtonAttributes = {
      className: 'event-joining-instruction-close-button',
      onClick() {
        onClose();
      }
    };

    return <div className='event-joining-instruction-dialog-header'>

      <label className='event-joining-instruction-dialog-header-label'>Joining Instructions</label>

      <button {...closeButtonAttributes}>
        <CloseIcon className='close-icon' />
      </button>

    </div>;
  }

  function renderJoiningInstruction() {

    return <label className='joining-instruction'>{instruction}</label>;

  }

  function renderMain() {

    const dialogProperties = {
      stackTopClass: 'async-dialog',
      contentHolderClassName: 'event-joining-instruction-display-dialog-holder',
      onClose() {
        onClose();
      }
    };

    return <SimpleDialog {...dialogProperties}>
      {renderDialogHeader()}
      {renderJoiningInstruction()}
    </SimpleDialog>;

  }

  return renderMain();

}

export default EventJoiningInstructions;